
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/announcement.js"
import * as amdModule1 from "./adapters/apis/rise-api.js"
import * as amdModule2 from "./adapters/apis/rise-api/content.js"
import * as amdModule3 from "./adapters/apis/rise-api/content/node.js"
import * as amdModule4 from "./adapters/apis/rise-api/data.js"
import * as amdModule5 from "./adapters/application.js"
import * as amdModule6 from "./adapters/catalog-record.js"
import * as amdModule7 from "./adapters/catalog-theme.js"
import * as amdModule8 from "./adapters/field.js"
import * as amdModule9 from "./adapters/file-gallery-file.js"
import * as amdModule10 from "./adapters/file-gallery.js"
import * as amdModule11 from "./adapters/help-page.js"
import * as amdModule12 from "./adapters/item.js"
import * as amdModule13 from "./adapters/location.js"
import * as amdModule14 from "./adapters/model-run-member.js"
import * as amdModule15 from "./adapters/model-run.js"
import * as amdModule16 from "./adapters/page.js"
import * as amdModule17 from "./adapters/ui-page.js"
import * as amdModule18 from "./config/config.js"
import * as amdModule19 from "./config/dates.js"
import * as amdModule20 from "./config/environment.js"
import * as amdModule21 from "./config/help-topic-keywords.js"
import * as amdModule22 from "./config/map.js"
import * as amdModule23 from "./config/rise-api.js"
import * as amdModule24 from "./config/search.js"
import * as amdModule25 from "./config/states.js"
import * as amdModule26 from "./config/strings.js"
import * as amdModule27 from "./config/time-series/graphs.js"
import * as amdModule28 from "./config/time-series/query-params.js"
import * as amdModule29 from "./config/ui-page.js"
import * as amdModule30 from "./decorators/class-mix.js"
import * as amdModule31 from "./decorators/complex-query-params.js"
import * as amdModule32 from "./deprecation-workflow.js"
import * as amdModule33 from "./instance-initializers/apis.js"
import * as amdModule34 from "./instance-initializers/breadcrumb.js"
import * as amdModule35 from "./instance-initializers/debug/debug-menu.js"
import * as amdModule36 from "./instance-initializers/links-to.js"
import * as amdModule37 from "./instance-initializers/menu.js"
import * as amdModule38 from "./instance-initializers/route-services.js"
import * as amdModule39 from "./instance-initializers/time-series-cache.js"
import * as amdModule40 from "./models/announcement.js"
import * as amdModule41 from "./models/catalog-record.js"
import * as amdModule42 from "./models/catalog-theme.js"
import * as amdModule43 from "./models/field.js"
import * as amdModule44 from "./models/file-gallery-file.js"
import * as amdModule45 from "./models/file-gallery.js"
import * as amdModule46 from "./models/help-page.js"
import * as amdModule47 from "./models/item.js"
import * as amdModule48 from "./models/location.js"
import * as amdModule49 from "./models/model-run-member.js"
import * as amdModule50 from "./models/model-run.js"
import * as amdModule51 from "./models/page.js"
import * as amdModule52 from "./models/types/node.js"
import * as amdModule53 from "./models/ui-page.js"
import * as amdModule54 from "./router.js"
import * as amdModule55 from "./serializers/announcement.js"
import * as amdModule56 from "./serializers/apis/rise-api/content.js"
import * as amdModule57 from "./serializers/apis/rise-api/content/node.js"
import * as amdModule58 from "./serializers/apis/rise-api/data.js"
import * as amdModule59 from "./serializers/application.js"
import * as amdModule60 from "./serializers/catalog-record.js"
import * as amdModule61 from "./serializers/catalog-theme.js"
import * as amdModule62 from "./serializers/field.js"
import * as amdModule63 from "./serializers/file-gallery-file.js"
import * as amdModule64 from "./serializers/file-gallery.js"
import * as amdModule65 from "./serializers/help-page.js"
import * as amdModule66 from "./serializers/item.js"
import * as amdModule67 from "./serializers/location.js"
import * as amdModule68 from "./serializers/model-run-member.js"
import * as amdModule69 from "./serializers/model-run.js"
import * as amdModule70 from "./serializers/page.js"
import * as amdModule71 from "./serializers/parameter.js"
import * as amdModule72 from "./serializers/ui-page.js"
import * as amdModule73 from "./services/announcements.js"
import * as amdModule74 from "./services/api-host-builder.js"
import * as amdModule75 from "./services/breadcrumb.js"
import * as amdModule76 from "./services/catalog-searches.js"
import * as amdModule77 from "./services/catalog-themes.js"
import * as amdModule78 from "./services/catalog/search-filters.js"
import * as amdModule79 from "./services/catalog/search-results.js"
import * as amdModule80 from "./services/catalog/search.js"
import * as amdModule81 from "./services/dataset.js"
import * as amdModule82 from "./services/debug/contact.js"
import * as amdModule83 from "./services/debug/debug-menu.js"
import * as amdModule84 from "./services/debug/time-series-output.js"
import * as amdModule85 from "./services/document-events.js"
import * as amdModule86 from "./services/dynamic-node.js"
import * as amdModule87 from "./services/field-height-overlays.js"
import * as amdModule88 from "./services/help-search.js"
import * as amdModule89 from "./services/keywords.js"
import * as amdModule90 from "./services/model/catalog-filters.js"
import * as amdModule91 from "./services/model/location-filters.js"
import * as amdModule92 from "./services/model/time-series-download-all.js"
import * as amdModule93 from "./services/model/time-series-download.js"
import * as amdModule94 from "./services/page-not-found-model-name.js"
import * as amdModule95 from "./services/page-not-found-model.js"
import * as amdModule96 from "./services/request-manager.js"
import * as amdModule97 from "./services/route/time-series.js"
import * as amdModule98 from "./services/routing.js"
import * as amdModule99 from "./services/scroll-root.js"
import * as amdModule100 from "./services/shoebox.js"
import * as amdModule101 from "./services/sticky.js"
import * as amdModule102 from "./services/store.js"
import * as amdModule103 from "./services/store/file-gallery.js"
import * as amdModule104 from "./services/time-series-queries.js"
import * as amdModule105 from "./services/time-series/dates.js"
import * as amdModule106 from "./services/time-series/graph-results.js"
import * as amdModule107 from "./services/time-series/outputs.js"
import * as amdModule108 from "./services/time-series/params.js"
import * as amdModule109 from "./services/time-series/search-filters.js"
import * as amdModule110 from "./services/time-series/search-results.js"
import * as amdModule111 from "./services/time-series/search.js"
import * as amdModule112 from "./services/time-series/selected-locations.js"
import * as amdModule113 from "./services/ui-pages.js"
import * as amdModule114 from "./services/url-register.js"
import * as amdModule115 from "./services/viewport.js"
import * as amdModule116 from "./ssr-stubs.js"
import * as amdModule117 from "./storages/catalog-searches.js"
import * as amdModule118 from "./storages/debug.js"
import * as amdModule119 from "./storages/time-series-alerts.js"
import * as amdModule120 from "./storages/time-series-queries.js"
import * as amdModule121 from "./transforms/boolean.js"
import * as amdModule122 from "./transforms/date.js"
import * as amdModule123 from "./transforms/elevation.js"
import * as amdModule124 from "./transforms/html.js"
import * as amdModule125 from "./transforms/hv-datum.js"
import * as amdModule126 from "./transforms/location-tags.js"
import * as amdModule127 from "./transforms/lowercase.js"
import * as amdModule128 from "./transforms/model-run-member.js"
import * as amdModule129 from "./transforms/number.js"
import * as amdModule130 from "./transforms/string.js"
import * as amdModule131 from "./instance-initializers/user-agent.js"
import * as amdModule132 from "./services/user-agent.js"
import * as amdModule133 from "./instance-initializers/add-modals-container.js"
import * as amdModule134 from "./services/modal-dialog.js"
import * as amdModule135 from "./services/-ensure-registered.js"
import * as amdModule136 from "./initializers/leaflet-assets.js"
import * as amdModule137 from "./services/ember-leaflet.js"
import * as amdModule138 from "./initializers/router-head-tags.js"
import * as amdModule139 from "./services/head-tags.js"
import * as amdModule140 from "./instance-initializers/head-browser.js"
import * as amdModule141 from "./services/head-data.js"
import * as amdModule142 from "./component-managers/glimmer.js"
import * as amdModule143 from "./services/route-state.js"
import * as amdModule144 from "./services/page-title.js"
import * as amdModule145 from "./initializers/ember-data.js"
import * as amdModule146 from "./data-adapter.js"
import * as amdModule147 from "./instance-initializers/clear-double-boot.js"
import * as amdModule148 from "./services/fastboot.js"
import * as amdModule149 from "./services/ssr.js"
import * as amdModule150 from "./services/notifications.js"
import * as amdModule151 from "./routes/about/template.gjs"
import * as amdModule152 from "./routes/about/route.js"
import * as amdModule153 from "./routes/account/template.gjs"
import * as amdModule154 from "./routes/account/route.js"
import * as amdModule155 from "./routes/announcement-error/template.gjs"
import * as amdModule156 from "./routes/announcement/template.gjs"
import * as amdModule157 from "./routes/announcement/route.js"
import * as amdModule158 from "./routes/announcements/template.gjs"
import * as amdModule159 from "./routes/announcements/route.js"
import * as amdModule160 from "./routes/application/template.gjs"
import * as amdModule161 from "./routes/application/route.js"
import * as amdModule162 from "./routes/catalog/route.js"
import * as amdModule163 from "./routes/catalog/index/template.gjs"
import * as amdModule164 from "./routes/catalog/index/route.js"
import * as amdModule165 from "./routes/catalog/record-error/template.gjs"
import * as amdModule166 from "./routes/catalog/record/route.js"
import * as amdModule167 from "./routes/catalog/record/index/template.gjs"
import * as amdModule168 from "./routes/catalog/record/index/route.js"
import * as amdModule169 from "./routes/catalog/record/item-error/template.gjs"
import * as amdModule170 from "./routes/catalog/record/item/template.gjs"
import * as amdModule171 from "./routes/catalog/record/item/route.js"
import * as amdModule172 from "./routes/contact/template.gjs"
import * as amdModule173 from "./routes/contact/route.js"
import * as amdModule174 from "./routes/error/template.gjs"
import * as amdModule175 from "./routes/file-gallery/template.gjs"
import * as amdModule176 from "./routes/file-gallery/route.js"
import * as amdModule177 from "./routes/help/template.gjs"
import * as amdModule178 from "./routes/help/route.js"
import * as amdModule179 from "./routes/help/index/template.gjs"
import * as amdModule180 from "./routes/help/index/route.js"
import * as amdModule181 from "./routes/help/page-error/template.gjs"
import * as amdModule182 from "./routes/help/page/template.gjs"
import * as amdModule183 from "./routes/help/page/route.js"
import * as amdModule184 from "./routes/help/search/index/template.gjs"
import * as amdModule185 from "./routes/help/search/index/route.js"
import * as amdModule186 from "./routes/help/search/topic/route.js"
import * as amdModule187 from "./routes/index/template.gjs"
import * as amdModule188 from "./routes/index/route.js"
import * as amdModule189 from "./routes/location-detail/template.gjs"
import * as amdModule190 from "./routes/location-detail/route.js"
import * as amdModule191 from "./routes/page-not-found/template.gjs"
import * as amdModule192 from "./routes/page-not-found/route.js"
import * as amdModule193 from "./routes/page/template.gjs"
import * as amdModule194 from "./routes/page/route.js"
import * as amdModule195 from "./routes/rise-api/template.gjs"
import * as amdModule196 from "./routes/rise-api/route.js"
import * as amdModule197 from "./routes/time-series/template.gjs"
import * as amdModule198 from "./routes/time-series/route.js"
import * as amdModule199 from "./routes/time-series/index/route.js"
import * as amdModule200 from "./routes/time-series/output/template.gjs"
import * as amdModule201 from "./routes/time-series/output/route.js"
import * as amdModule202 from "./routes/time-series/search/template.gjs"
import * as amdModule203 from "./routes/time-series/search/route.js"
import * as amdModule204 from "./routes/time-series/selection/template.gjs"
import * as amdModule205 from "./routes/time-series/selection/route.js"
import * as amdModule206 from "./routes/visualizations/template.gjs"
import * as amdModule207 from "./routes/visualizations/route.js"
import * as amdModule208 from "./templates/head.hbs"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"rise-ui/adapters/announcement": amdModule0,
"rise-ui/adapters/apis/rise-api": amdModule1,
"rise-ui/adapters/apis/rise-api/content": amdModule2,
"rise-ui/adapters/apis/rise-api/content/node": amdModule3,
"rise-ui/adapters/apis/rise-api/data": amdModule4,
"rise-ui/adapters/application": amdModule5,
"rise-ui/adapters/catalog-record": amdModule6,
"rise-ui/adapters/catalog-theme": amdModule7,
"rise-ui/adapters/field": amdModule8,
"rise-ui/adapters/file-gallery-file": amdModule9,
"rise-ui/adapters/file-gallery": amdModule10,
"rise-ui/adapters/help-page": amdModule11,
"rise-ui/adapters/item": amdModule12,
"rise-ui/adapters/location": amdModule13,
"rise-ui/adapters/model-run-member": amdModule14,
"rise-ui/adapters/model-run": amdModule15,
"rise-ui/adapters/page": amdModule16,
"rise-ui/adapters/ui-page": amdModule17,
"rise-ui/config/config": amdModule18,
"rise-ui/config/dates": amdModule19,
"rise-ui/config/environment": amdModule20,
"rise-ui/config/help-topic-keywords": amdModule21,
"rise-ui/config/map": amdModule22,
"rise-ui/config/rise-api": amdModule23,
"rise-ui/config/search": amdModule24,
"rise-ui/config/states": amdModule25,
"rise-ui/config/strings": amdModule26,
"rise-ui/config/time-series/graphs": amdModule27,
"rise-ui/config/time-series/query-params": amdModule28,
"rise-ui/config/ui-page": amdModule29,
"rise-ui/decorators/class-mix": amdModule30,
"rise-ui/decorators/complex-query-params": amdModule31,
"rise-ui/deprecation-workflow": amdModule32,
"rise-ui/instance-initializers/apis": amdModule33,
"rise-ui/instance-initializers/breadcrumb": amdModule34,
"rise-ui/instance-initializers/debug/debug-menu": amdModule35,
"rise-ui/instance-initializers/links-to": amdModule36,
"rise-ui/instance-initializers/menu": amdModule37,
"rise-ui/instance-initializers/route-services": amdModule38,
"rise-ui/instance-initializers/time-series-cache": amdModule39,
"rise-ui/models/announcement": amdModule40,
"rise-ui/models/catalog-record": amdModule41,
"rise-ui/models/catalog-theme": amdModule42,
"rise-ui/models/field": amdModule43,
"rise-ui/models/file-gallery-file": amdModule44,
"rise-ui/models/file-gallery": amdModule45,
"rise-ui/models/help-page": amdModule46,
"rise-ui/models/item": amdModule47,
"rise-ui/models/location": amdModule48,
"rise-ui/models/model-run-member": amdModule49,
"rise-ui/models/model-run": amdModule50,
"rise-ui/models/page": amdModule51,
"rise-ui/models/types/node": amdModule52,
"rise-ui/models/ui-page": amdModule53,
"rise-ui/router": amdModule54,
"rise-ui/serializers/announcement": amdModule55,
"rise-ui/serializers/apis/rise-api/content": amdModule56,
"rise-ui/serializers/apis/rise-api/content/node": amdModule57,
"rise-ui/serializers/apis/rise-api/data": amdModule58,
"rise-ui/serializers/application": amdModule59,
"rise-ui/serializers/catalog-record": amdModule60,
"rise-ui/serializers/catalog-theme": amdModule61,
"rise-ui/serializers/field": amdModule62,
"rise-ui/serializers/file-gallery-file": amdModule63,
"rise-ui/serializers/file-gallery": amdModule64,
"rise-ui/serializers/help-page": amdModule65,
"rise-ui/serializers/item": amdModule66,
"rise-ui/serializers/location": amdModule67,
"rise-ui/serializers/model-run-member": amdModule68,
"rise-ui/serializers/model-run": amdModule69,
"rise-ui/serializers/page": amdModule70,
"rise-ui/serializers/parameter": amdModule71,
"rise-ui/serializers/ui-page": amdModule72,
"rise-ui/services/announcements": amdModule73,
"rise-ui/services/api-host-builder": amdModule74,
"rise-ui/services/breadcrumb": amdModule75,
"rise-ui/services/catalog-searches": amdModule76,
"rise-ui/services/catalog-themes": amdModule77,
"rise-ui/services/catalog/search-filters": amdModule78,
"rise-ui/services/catalog/search-results": amdModule79,
"rise-ui/services/catalog/search": amdModule80,
"rise-ui/services/dataset": amdModule81,
"rise-ui/services/debug/contact": amdModule82,
"rise-ui/services/debug/debug-menu": amdModule83,
"rise-ui/services/debug/time-series-output": amdModule84,
"rise-ui/services/document-events": amdModule85,
"rise-ui/services/dynamic-node": amdModule86,
"rise-ui/services/field-height-overlays": amdModule87,
"rise-ui/services/help-search": amdModule88,
"rise-ui/services/keywords": amdModule89,
"rise-ui/services/model/catalog-filters": amdModule90,
"rise-ui/services/model/location-filters": amdModule91,
"rise-ui/services/model/time-series-download-all": amdModule92,
"rise-ui/services/model/time-series-download": amdModule93,
"rise-ui/services/page-not-found-model-name": amdModule94,
"rise-ui/services/page-not-found-model": amdModule95,
"rise-ui/services/request-manager": amdModule96,
"rise-ui/services/route/time-series": amdModule97,
"rise-ui/services/routing": amdModule98,
"rise-ui/services/scroll-root": amdModule99,
"rise-ui/services/shoebox": amdModule100,
"rise-ui/services/sticky": amdModule101,
"rise-ui/services/store": amdModule102,
"rise-ui/services/store/file-gallery": amdModule103,
"rise-ui/services/time-series-queries": amdModule104,
"rise-ui/services/time-series/dates": amdModule105,
"rise-ui/services/time-series/graph-results": amdModule106,
"rise-ui/services/time-series/outputs": amdModule107,
"rise-ui/services/time-series/params": amdModule108,
"rise-ui/services/time-series/search-filters": amdModule109,
"rise-ui/services/time-series/search-results": amdModule110,
"rise-ui/services/time-series/search": amdModule111,
"rise-ui/services/time-series/selected-locations": amdModule112,
"rise-ui/services/ui-pages": amdModule113,
"rise-ui/services/url-register": amdModule114,
"rise-ui/services/viewport": amdModule115,
"rise-ui/ssr-stubs": amdModule116,
"rise-ui/storages/catalog-searches": amdModule117,
"rise-ui/storages/debug": amdModule118,
"rise-ui/storages/time-series-alerts": amdModule119,
"rise-ui/storages/time-series-queries": amdModule120,
"rise-ui/transforms/boolean": amdModule121,
"rise-ui/transforms/date": amdModule122,
"rise-ui/transforms/elevation": amdModule123,
"rise-ui/transforms/html": amdModule124,
"rise-ui/transforms/hv-datum": amdModule125,
"rise-ui/transforms/location-tags": amdModule126,
"rise-ui/transforms/lowercase": amdModule127,
"rise-ui/transforms/model-run-member": amdModule128,
"rise-ui/transforms/number": amdModule129,
"rise-ui/transforms/string": amdModule130,
"rise-ui/instance-initializers/user-agent": amdModule131,
"rise-ui/services/user-agent": amdModule132,
"rise-ui/instance-initializers/add-modals-container": amdModule133,
"rise-ui/services/modal-dialog": amdModule134,
"rise-ui/services/-ensure-registered": amdModule135,
"rise-ui/initializers/leaflet-assets": amdModule136,
"rise-ui/services/ember-leaflet": amdModule137,
"rise-ui/initializers/router-head-tags": amdModule138,
"rise-ui/services/head-tags": amdModule139,
"rise-ui/instance-initializers/head-browser": amdModule140,
"rise-ui/services/head-data": amdModule141,
"rise-ui/component-managers/glimmer": amdModule142,
"rise-ui/services/route-state": amdModule143,
"rise-ui/services/page-title": amdModule144,
"rise-ui/initializers/ember-data": amdModule145,
"rise-ui/data-adapter": amdModule146,
"rise-ui/instance-initializers/clear-double-boot": amdModule147,
"rise-ui/services/fastboot": amdModule148,
"rise-ui/services/ssr": amdModule149,
"rise-ui/services/notifications": amdModule150,
"rise-ui/routes/about/template": amdModule151,
"rise-ui/routes/about/route": amdModule152,
"rise-ui/routes/account/template": amdModule153,
"rise-ui/routes/account/route": amdModule154,
"rise-ui/routes/announcement-error/template": amdModule155,
"rise-ui/routes/announcement/template": amdModule156,
"rise-ui/routes/announcement/route": amdModule157,
"rise-ui/routes/announcements/template": amdModule158,
"rise-ui/routes/announcements/route": amdModule159,
"rise-ui/routes/application/template": amdModule160,
"rise-ui/routes/application/route": amdModule161,
"rise-ui/routes/catalog/route": amdModule162,
"rise-ui/routes/catalog/index/template": amdModule163,
"rise-ui/routes/catalog/index/route": amdModule164,
"rise-ui/routes/catalog/record-error/template": amdModule165,
"rise-ui/routes/catalog/record/route": amdModule166,
"rise-ui/routes/catalog/record/index/template": amdModule167,
"rise-ui/routes/catalog/record/index/route": amdModule168,
"rise-ui/routes/catalog/record/item-error/template": amdModule169,
"rise-ui/routes/catalog/record/item/template": amdModule170,
"rise-ui/routes/catalog/record/item/route": amdModule171,
"rise-ui/routes/contact/template": amdModule172,
"rise-ui/routes/contact/route": amdModule173,
"rise-ui/routes/error/template": amdModule174,
"rise-ui/routes/file-gallery/template": amdModule175,
"rise-ui/routes/file-gallery/route": amdModule176,
"rise-ui/routes/help/template": amdModule177,
"rise-ui/routes/help/route": amdModule178,
"rise-ui/routes/help/index/template": amdModule179,
"rise-ui/routes/help/index/route": amdModule180,
"rise-ui/routes/help/page-error/template": amdModule181,
"rise-ui/routes/help/page/template": amdModule182,
"rise-ui/routes/help/page/route": amdModule183,
"rise-ui/routes/help/search/index/template": amdModule184,
"rise-ui/routes/help/search/index/route": amdModule185,
"rise-ui/routes/help/search/topic/route": amdModule186,
"rise-ui/routes/index/template": amdModule187,
"rise-ui/routes/index/route": amdModule188,
"rise-ui/routes/location-detail/template": amdModule189,
"rise-ui/routes/location-detail/route": amdModule190,
"rise-ui/routes/page-not-found/template": amdModule191,
"rise-ui/routes/page-not-found/route": amdModule192,
"rise-ui/routes/page/template": amdModule193,
"rise-ui/routes/page/route": amdModule194,
"rise-ui/routes/rise-api/template": amdModule195,
"rise-ui/routes/rise-api/route": amdModule196,
"rise-ui/routes/time-series/template": amdModule197,
"rise-ui/routes/time-series/route": amdModule198,
"rise-ui/routes/time-series/index/route": amdModule199,
"rise-ui/routes/time-series/output/template": amdModule200,
"rise-ui/routes/time-series/output/route": amdModule201,
"rise-ui/routes/time-series/search/template": amdModule202,
"rise-ui/routes/time-series/search/route": amdModule203,
"rise-ui/routes/time-series/selection/template": amdModule204,
"rise-ui/routes/time-series/selection/route": amdModule205,
"rise-ui/routes/visualizations/template": amdModule206,
"rise-ui/routes/visualizations/route": amdModule207,
"rise-ui/templates/head": amdModule208,
  },
  exportFastbootModules
);
